import { Injectable } from '@angular/core';
import {
	createFeatureSelector,
	createSelector,
	select,
	Store,
} from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { CORE, CoreState, IAppRootState } from './app.state';
import { UserOrganization } from '../domain/user-organization';
import { UserPreference } from '../domain/user-preference';
import { UserProfile } from '../domain/user-profile';

export const coreSelector = createFeatureSelector<CoreState>(CORE);

export const ConnectedUser = createSelector(coreSelector, (state: CoreState) =>
	state.get('connectedUser'),
);

export const CurrentOrganization = createSelector(
	coreSelector,
	(state: CoreState) => state.get('organization'),
);

@Injectable({
	providedIn: 'root',
})
export class AppSelector {
	public constructor(private readonly store: Store<IAppRootState>) {}

	private get state(): Observable<CoreState> {
		return this.store.pipe(select((store) => store[CORE]));
	}

	public getCurrentOrganization$(): Observable<UserOrganization> {
		return this.store.pipe(select(CurrentOrganization));
	}

	public getConnectedUser$(): Observable<UserProfile> {
		return this.store.pipe(select(ConnectedUser));
	}

	public getPreferences$(): Observable<UserPreference> {
		return this.state.pipe(map((state) => state.get('userPreference')));
	}
}
